/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2015, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../UndoRedoButton'
], function(BaseClass) {

	const Button = BaseClass.extend({
		onPress: function(){
			const dashboard = this.glassContext.appController.getCurrentContentView().getDashboardApi();
			if (dashboard) {
				dashboard.redo();
			}
		},

		canEnable: function(controller) {
			return controller.canRedo();
		}
	});
	return Button;
});
